import { optionsConfig } from 'ngx-mask';

export const NGX_MASK_CONFIGURATION: optionsConfig = {
  dropSpecialCharacters: false
};
